import { useEffect } from "react";
import { useRouter } from "next/router";
import classNames from "@lib/classNames";

export interface TextBlockProps {
  content: string;
}

export const TextBlock: React.FC<TextBlockProps> = ({ content }) => {
  const router = useRouter();
  const isCloudjoiStack = router.asPath.includes("cloudjoi");

  useEffect(() => {
    document.querySelectorAll(".cloudjoi-text-block a").forEach((el) => {
      const element = el as HTMLAnchorElement;
      const url = new URL(element.href);
      url.searchParams.set("referral", "lumi-news-web");

      element.href = url.toString();
    });
  }, []);

  return (
    <div
      className={classNames(
        "rich-news-stack-text",
        isCloudjoiStack && "cloudjoi-text-block"
      )}
      dangerouslySetInnerHTML={{ __html: content }}
    ></div>
  );
};

export default {
  name: "text",
  inputNames: ["content"],
  defaultProps: {
    content: "",
  },
  component: TextBlock,
};
